
import { useEffect, useState } from "react";
import MainNav from "@/components/navigation/MainNav";
import Scene from "@/components/Scene";
import { useIsMobile } from "@/hooks/use-mobile";
import { supabase } from "@/integrations/supabase/client";
import { HeroSection } from "@/components/HeroSection";
import { ErrorBoundary } from "react-error-boundary";
import Footer from "@/components/Footer";

const Index = () => {
  console.log("Index component rendering");
  const isMobile = useIsMobile();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [sceneError, setSceneError] = useState<Error | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        setIsAuthenticated(!!session);
      } catch (error) {
        console.error("Auth check error:", error);
      }
    };

    checkAuth();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setIsAuthenticated(!!session);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-gray-50 to-gray-100">
      <MainNav />
      
      <main className="container mx-auto px-4 py-8 flex-grow">
        <HeroSection />
        
        <div className="mt-12 h-[400px] rounded-lg overflow-hidden shadow-xl">
          <ErrorBoundary 
            fallback={<div className="p-4 text-red-500">Error loading 3D scene</div>}
            onError={(error) => {
              console.error("Scene error:", error);
              setSceneError(error);
            }}
          >
            <Scene drillText="Basic formation" />
          </ErrorBoundary>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Index;
